






































import { RangeFilter, RangeValue } from '@empathy/search-types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { DynamicRangeMessages } from '../../../i18n';
import { VueCssClasses } from '../../../utils';
import { KeyCodes } from '../components.const';

const VALID_KEYCODES = [
  KeyCodes.Backspace,
  KeyCodes.Tab,
  KeyCodes.Enter,
  KeyCodes.LeftArrow,
  KeyCodes.UpArrow,
  KeyCodes.RightArrow,
  KeyCodes.DownArrow,
  KeyCodes.Delete
];

@Component
export default class DynamicRangeFilter extends Vue {

  @Prop({ required: true })
  filter: RangeFilter;

  // Modifier .number of vue when input is empty return a empty string
  min: number | string = this.filter.value.min;
  max: number | string = this.filter.value.max;

  get messages(): DynamicRangeMessages {
    return ((this.$x.messages.facets.values[this.filter.facet.modelName] ||
      this.$x.messages.facets.defaultDynamicRange)) as DynamicRangeMessages;
  }

  get currency() {
    return this.$x.currency.currencySymbol;
  }

  get cssClasses(): VueCssClasses {
    return {
      'ebx-dynamic-filter--empty': this.bothInputsAreEmpty,
      'ebx-dynamic-filter--selected': this.filter.selected,
      'ebx-dynamic-filter--error': !this.isValidValue
    };
  }

  get bothInputsAreEmpty(): boolean {
    const minIsEmpty = typeof this.min !== 'number';
    const maxIsEmpty = typeof this.max !== 'number';
    return minIsEmpty && maxIsEmpty;
  }

  get isValidValue(): boolean {
    const minIsEmpty = typeof this.min !== 'number';
    const maxIsEmpty = typeof this.max !== 'number';
    const maxIsGreaterOrEqualThanMin = (minIsEmpty || maxIsEmpty) || this.max >= this.min;
    const minIsPositive = this.min >= 0;
    const maxIsPositive = this.max >= 0;
    return this.bothInputsAreEmpty || (minIsPositive && maxIsPositive && maxIsGreaterOrEqualThanMin);
  }

  @Watch('filter.value', { deep: true })
  synchronizeFilterValues(value: RangeValue) {
    this.min = value.min;
    this.max = value.max;
  }

  clearFilter() {
    this.min = this.max = null;
    this.updateFilterValue();
    this.$x.emit(EVENTS.DynamicFilterCleared, this.filter);
  }

  updateValueAndApplyFilter() {
    if (this.isValidValue) {
      this.updateFilterValue();
      if (this.min || this.max) {
        this.$x.emit(EVENTS.DynamicFilterSelected, this.filter);
      } else {
        this.clearFilter();
      }
    }
  }

  updateFilterValue() {
    this.$x.emit(EVENTS.FilterValueChanged, {
      filter: this.filter,
      newFilter: {
        value: {
          min: typeof this.min === 'string' ? null : this.min,
          max: typeof this.max === 'string' ? null : this.max
        },
        id: `${this.filter.facet.modelName}:${this.min} TO ${this.max}`
      }
    });
  }

  onKeyDown(event: KeyboardEvent) {
    const keyCode: number = Number.parseInt(event.code, 10);
    // KeyCodes in the range [47-57] matches numbers from 0-9
    if (!VALID_KEYCODES.includes(keyCode) && (keyCode < 48 || keyCode > 57)) {
      event.preventDefault();
    }
  }
}
